import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { postAdditionMerchantGeneralBlockList } from '@src/api'
import {
  DefaultApiPostAdditionMerchantGeneralBlockListRequest,
  PostAdditionMerchantGeneralBlockList200Response,
} from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

import { PostAdditionMerchantGeneralBlockListError } from './type'

export const usePostAdditionMerchantGeneralBlockList = () => {
  const { axiosInstance } = useAxios()

  return useMutation<
    AxiosResponse<PostAdditionMerchantGeneralBlockList200Response>,
    AxiosResponse<PostAdditionMerchantGeneralBlockListError>,
    DefaultApiPostAdditionMerchantGeneralBlockListRequest
  >({
    mutationFn: (
      params: DefaultApiPostAdditionMerchantGeneralBlockListRequest
    ) => postAdditionMerchantGeneralBlockList(axiosInstance, params),
  })
}
